import { Button, Form, Input, Space, Table } from "antd"
import { useReducer, useState } from "react";
import { ViewSalesLead, buildStateForSave, createViewSalesLead, defaultSalesLeadsState, hasChanges } from "./salesLeadsModel";
import { faFloppyDisk } from "@fortawesome/pro-solid-svg-icons";
import { useSalesLeads, useSaveSalesLeadsMutation } from "./salesLeadsQueries";
import { DeleteButton } from "../../common/DeleteButton";
import { reducer } from "./salesLeadsReducer";
import { UndeleteButton } from "../../common/UndeleteButton";
import { styleDeletedRows } from '../../Items/styleDeletedRows'
import IconAndTextButton from "../../IconAndTextButton";

const StyledTable = styleDeletedRows<typeof Table<ViewSalesLead>>(Table)

const SalesLeadsForm = () => {
  const [state, dispatch] = useReducer(reducer, defaultSalesLeadsState())
  const [newSalesLeadName, setNewSalesLeadName] = useState('')
  const salesLeadsQuery = useSalesLeads()
  const serverSalesLeads = salesLeadsQuery.data ?? []
  const viewSalesLeads: ViewSalesLead[] = createViewSalesLead(state, serverSalesLeads)
  const hasStateChanges = hasChanges(state)
  const saveSalesLeadsMutation = useSaveSalesLeadsMutation(() => {
    dispatch({ type: 'SALES_LEADS_SAVE' })
  })
  const [form] = Form.useForm()

  return <>
    <Form layout="vertical" form={form}>
      <Form.Item style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <IconAndTextButton type="primary" size="large" disabled={!hasStateChanges}
          onClick={() => { saveSalesLeadsMutation.mutate({ changeSet: buildStateForSave(state) }) }}
          icon={faFloppyDisk} text="Save"
        />
      </Form.Item>
      <Form.Item label="Sales Lead">
        <Input placeholder="Enter your new sales lead"
          value={newSalesLeadName}
          onChange={e => setNewSalesLeadName(e.target.value)}
        />
      </Form.Item>
      <Form.Item>
        <Space>
          <Button
            type="primary"
            size="large"
            onClick={() => {
              dispatch({ type: 'SALES_LEADS_ADDED', value: newSalesLeadName })
              setNewSalesLeadName('')
            }}
          >
            Add Sales Lead
          </Button>
        </Space>
      </Form.Item>
      <Form.Item>
        <StyledTable
          dataSource={viewSalesLeads}
          rowKey='id'
          rowClassName={(salesLead: ViewSalesLead) => salesLead.isDeleted ? 'deleted' : ''}
          pagination={false}
          columns={[
            {
              title: 'Sales Lead',
              dataIndex: 'name',
              key: 'name',
              render: (_, { name, id, isDeleted }) => (
                <>
                  <Input
                    value={name}
                    onChange={e => dispatch({ type: 'SALES_LEADS_CHANGED', serverSalesLeads: serverSalesLeads ?? [], value: e.target.value, salesLeadId: id })}
                    disabled={isDeleted}
                  />
                </>
              ),
            },
            {
              align: 'right',
              render: (_, salesLead) => {
                return salesLead.isDeleted
                  ? <UndeleteButton onClick={() => {
                    dispatch({ type: 'SALES_LEADS_UNDELETED', salesLeadId: salesLead.id })
                  }} />
                  : <DeleteButton onClick={() => {
                    dispatch({ type: 'SALES_LEADS_DELETED', salesLeadId: salesLead.id })
                  }} />
              }
            }
          ]}
        />
      </Form.Item>
    </Form>
  </>
}

export default SalesLeadsForm
